import { Box, Tabs, Tab } from '@mui/material';
import Link from 'next/link';

const NavigationTabsComponent = ({ tabs, activeTab = 0, activeSubTab = 0 }) => {
    const tabSeleccionada = tabs.find((_tab, index) => index === activeTab);
    return (
        <Box display="flex" flexDirection="column" alignItems="center" width="100%">
            <Tabs value={activeTab} aria-label="navigation tabs">
                {tabs.map((tab, index) => (
                    <Tab
                        key={index}
                        label={tab.label}
                        component={Link}
                        href={tab.url}
                        sx={{ textTransform: 'none', fontSize: 14 }}
                    />
                ))}
            </Tabs>

            {tabSeleccionada?.subTabs?.length > 0 && (
                <Tabs value={activeSubTab} aria-label="navigation tabs">
                    {tabSeleccionada?.subTabs?.map((subTab, index) => (
                        <Tab
                            key={`${index}-${subTab.label}`}
                            label={subTab.label}
                            component={Link}
                            href={subTab.url}
                            sx={{ textTransform: 'none', fontSize: 14 }}
                            icon={subTab.icon}
                        />
                    ))}
                </Tabs>
            )}
        </Box>
    );
};

export default NavigationTabsComponent;
